import { deleteDoc, doc } from "firebase/firestore";
import { useState } from "react";

import { authClasses } from "../../../pages/Auth/authClasses";
import { db } from "../../../firebase";

const UnregisterPopup = ({
	athlete,
	evnt,
	setUnregisterEvent,
	removeEventRegistration,
}) => {
	const { buttonSmall } = authClasses;

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const handleUnregister = async () => {
		setLoading(true);
		const regID = athlete.registrations.find((a) => a.id === evnt.id).regID;
		const docRef = doc(db, "registrations", regID);

		try {
			await deleteDoc(docRef);
			setLoading(false);
			setUnregisterEvent(null);
			removeEventRegistration(athlete.id, regID);
		} catch (err) {
			setError(err);
			setLoading(false);
		}
	};

	return (
		<div className="fixed inset-0 z-20 flex items-center justify-center overflow-y-auto bg-black/75 px-4 py-6">
			<div className="grid max-h-[92vh] w-full max-w-2xl gap-5 overflow-y-auto rounded-lg border border-white/10 bg-[#24262c] p-5 shadow-2xl shadow-black/40">
				{error ? (
					<div className="grid gap-3">
						<h3 className="m-0 text-2xl text-white">
							Error Withdrawing from Event
						</h3>
						<p className="m-0 text-sm text-slate-300">
							Email director@sidewinderva.com if this keeps happening.
						</p>
						<small className="rounded-md border border-red-300/30 bg-red-500/15 p-3 text-red-100">
							{error.toString()}
						</small>
						<button
							className={buttonSmall}
							onClick={() => {
								setError(null);
								setUnregisterEvent(null);
							}}
						>
							Ok
						</button>
					</div>
				) : (
					<div className="grid gap-5">
						<div className="grid gap-2 border-b border-white/10 pb-4">
							<span className="text-xs font-bold uppercase tracking-[0.18em] text-accent-color-2">
								Withdraw
							</span>
							<h3 className="m-0 text-2xl text-white">
								Withdraw from this event?
							</h3>
							<p className="m-0 text-sm text-slate-300">
								This removes the unpaid registration from your account.
							</p>
						</div>

						<div className="grid gap-2 rounded-md border border-white/10 bg-black/20 p-4 text-sm text-slate-300">
							<p className="m-0">
								Athlete:{" "}
								<strong className="text-white">
									{athlete.firstName} {athlete.lastName}
								</strong>
							</p>
							<p className="m-0">
								Event:{" "}
								<strong className="text-white">
									{evnt.title} - {evnt.dateString}
								</strong>
							</p>
							{evnt.session ? (
								<p className="m-0">
									Session: <strong className="text-white">{evnt.session}</strong>
								</p>
							) : null}
						</div>

						{evnt.type !== "Tryout" ? (
							<div className="rounded-md border border-yellow-300/30 bg-yellow-500/10 p-3 text-sm text-yellow-100">
								If this event closes or sells out, you may not be able to
								re-register after withdrawing.
							</div>
						) : null}

						<div className="flex flex-wrap justify-end gap-3 border-t border-white/10 pt-4">
							<button
								className={`${buttonSmall} border-white/10 bg-[#333333] hover:bg-[#3f3f3f]`}
								disabled={loading}
								onClick={() => setUnregisterEvent(null)}
							>
								Cancel
							</button>
							<button
								className={`${buttonSmall} border-red-300/30 bg-red-500/15 text-red-100 hover:border-red-200/50 hover:bg-red-500/25`}
								onClick={() => handleUnregister()}
								disabled={loading}
							>
								{loading ? "Withdrawing..." : "Withdraw"}
							</button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default UnregisterPopup;
